import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Elements,
  injectStripe,
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
} from 'react-stripe-elements';
import { noop } from 'lodash';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import TextField from '@material-ui/core/TextField';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';

import {
  injectIntl,
  SmartDialog,
} from 'components';
// import { injectIntl, } from '../Intl';

class _PaymentDetailForm extends Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    paymentType: PropTypes.string.isRequired,
    stripe: PropTypes.shape({}),
    formatMessage: PropTypes.func.isRequired,
    onClose: PropTypes.func,
  }

  static defaultProps = {
    stripe: null,
    paymentType: 'bank_account',
    onClose: noop,
  }

  state = {
    accountNumber: '',
    holderName: '',
    holderType: 'individual',
    routingNumber: '',
    paymentType: this.props.paymentType || 'bank_account',
  }

  componentWillReceiveProps({ paymentType }) {
    if (this.props.paymentType !== paymentType && this.state.paymentType !== paymentType) {
      this.setState({ paymentType });
    }
  }

  handleSubmit = (ev) => {
    ev.preventDefault();
    const { stripe, onSubmit } = this.props;
    const { paymentType } = this.state;
    if (stripe) {
      if (paymentType === 'bank_account') {
        stripe.createToken('bank_account', {
          account_number: this.state.accountNumber,
          account_holder_name: this.state.holderName,
          account_holder_type: this.state.holderType,
          country: 'US',
          currency: 'usd',
          routing_number: this.state.routingNumber,
        }).then(({ token }) => {
          onSubmit(token.id);
        });
      } else if (paymentType === 'card') {
        stripe.createToken().then(({ token }) => {
          if (!token) {
            alert('Your card is not valid');
          } else {
            onSubmit(token.id);
          }
        });
      }
    }
  };

  renderCardForm() {
    const {stripe} = this.props;
    return (
      <div>
        <label>
          Card number
          <CardNumberElement />
        </label>
        <label>
          Expiration date
          <CardExpiryElement />
        </label>
        <label>
          CVC
          <CardCVCElement />
        </label>
      </div>
    );
  }

  renderACHForm() {
    const { formatMessage } = this.props;
    const {
      accountNumber,
      holderName,
      holderType,
      routingNumber,
    } = this.state;
    return (
      <div className="payment-form">
        <label>
          {formatMessage('Account Holder Type')}
          <RadioGroup
            className="radio-group"
            name="accountHolderType"
            onChange={e => this.setState({ holderType: e.target.value })}
            required={this.state.paymentType !== "card"}
            value={holderType}
          >
            <FormControlLabel
              control={<Radio />}
              label={formatMessage('Individual')}
              value="individual"
            />
            <FormControlLabel
              control={<Radio />}
              label={formatMessage('Business')}
              value="company"
            />
          </RadioGroup>
        </label>
        <label>
          {formatMessage('Account Holder Name')}
          <TextField
            className="input"
            InputProps={{ disableUnderline: true }}
            name="accountHolderName"
            onChange={e => this.setState({ holderName: e.target.value })}
            placeholder={formatMessage('e.g. Jenny Rosen')}
            required={this.state.paymentType !== "card"}
            value={holderName}
          />
        </label>
        <label>
          {formatMessage('Routing Number')}
          <TextField
            className="input"
            InputProps={{ disableUnderline: true }}
            name="routingNumber"
            onChange={e => this.setState({ routingNumber: e.target.value })}
            placeholder={formatMessage('e.g. 110000000')}
            required={this.state.paymentType !== "card"}
            value={routingNumber}
          />
        </label>
        <label>
          {formatMessage('Account Number')}
          <TextField
            className="input"
            InputProps={{ disableUnderline: true }}
            name="accountNumber"
            onChange={e => this.setState({ accountNumber: e.target.value })}
            placeholder={formatMessage('e.g. 000123456789')}
            required={this.state.paymentType !== "card"}
            value={accountNumber}
          />
        </label>
      </div>
    );
  }

  render() {
    const {
      formatMessage,
      loading,
      onClose,
    } = this.props;
    const { paymentType } = this.state;
    return (
      <form onSubmit={this.handleSubmit}>
        <Tabs
          className="add-payment-type-tabs"
          onChange={(event, paymentType) => this.setState({ paymentType })}
          value={paymentType}
        >
          <Tab
            label={formatMessage('Credit Card')}
            value="card"
            id="simple-tab-0"
            aria-controls="simple-tabpanel-0"
          />
          <Tab
            label={formatMessage('ACH')}
            value="bank_account"
            id="simple-tab-1"
            aria-controls="simple-tabpanel-1"
          />
        </Tabs>

        <Typography
          component="div"
          role="tabpanel"
          hidden={this.state.paymentType !== "card"}
          id={`simple-tabpanel-0`}
          aria-labelledby={`simple-tab-0`}
        >
          {this.renderCardForm()}
        </Typography>

        <Typography
          component="div"
          role="tabpanel"
          hidden={this.state.paymentType !== "bank_account"}
          id={`simple-tabpanel-1`}
          aria-labelledby={`simple-tab-1`}
        >
          {this.renderACHForm()}
        </Typography>

        <button className="submit-button">{formatMessage('SUBMIT')}</button>
        <button type="button" onClick={onClose}>{formatMessage('CANCEL')}</button>
        {loading && (
          <CircularProgress style={{
            left: 20,
            top: 17,
          }} />)
        }
      </form>
    );
  }
}
const PaymentDetailForm = injectStripe(_PaymentDetailForm);

class AddPaymentDetailDialog extends Component {
  static propTypes = {
    initialPaymentType: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,

    formatMessage: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    submitToken: PropTypes.func.isRequired,
  };

  static defaultProps = {
    initialPaymentType: 'bank_account',
  };

  render() {
    const {
      initialPaymentType: paymentType,
      loading,
      onClose,
      open,
      submitToken,
      title,
      formatMessage,
    } = this.props;

    return (
      <SmartDialog
        onClose={onClose}
        open={open}
        title={title}
      >
        <div className="add-payment-detail-dialog">
          <Elements>
            <PaymentDetailForm
              formatMessage={formatMessage}
              loading={loading}
              onSubmit={submitToken}
              open={open}
              paymentType={paymentType}
              onClose={onClose}
            />
          </Elements>
        </div>
      </SmartDialog>
    );
  }
}

const wrappedAddPaymentDetailDialog = injectIntl(AddPaymentDetailDialog);
wrappedAddPaymentDetailDialog.displayName = 'AddPaymentDetailDialog';

export default wrappedAddPaymentDetailDialog;
